<template>
	<div>
		<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="Book_closed" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g>
					<rect id="bg-tabbar-icon" x="0" y="0" width="44" height="44"></rect>
					<path d="M34.54,42.24 C36.839,42.24 38.72,40.4184 38.72,38.192 L38.72,5.808 C38.72,3.5816 36.839,1.76 34.54,1.76 L22,1.76 L22,15.928 L16.775,12.892 L11.55,15.928 L11.55,1.76 L9.46,1.76 C7.161,1.76 5.28,3.5816 5.28,5.808 L5.28,38.192 C5.28,40.4184 7.161,42.24 9.46,42.24 L34.54,42.24 Z" id="Path" :fill="color" fill-rule="nonzero"></path>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBank',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
};
</script>

<style scoped>

</style>